import React, { useState, useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'
import moment from 'moment'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField
} from '@material-ui/core'
import {
  SelectValidator,
  TextValidator,
  ValidatorForm
} from 'react-material-ui-form-validator'
import { Autocomplete } from "@material-ui/lab"
import { movimentoInsumoAction, tipoMovimentoInsumoAction, totvsInsumoAction, totvsProdutoAction } from '../../_actions'
import { withRouter } from 'react-router-dom'
import { history } from '../../utils'
import SaveIcon from '@material-ui/icons/Save'
import { EditorHeader, Page } from 'components'
import { isEmpty } from 'lodash'

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlgin: 'center'
  },
  nome: {
    marginTop: theme.spacing(1)
  },
  uploadButton: {
    marginRight: theme.spacing(2),
    justifyContent: 'space-between'
  },
  avatar: {
    height: 200,
    width: 200,
    borderRadius: '10px',
    webkitBorderRadius: '10px',
    mozBorderRadius: '10px',
    cursor: 'pointer'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
})

const MovimentoInsumoEdit = (props) => {

  const dispatch = useDispatch()
  const { classes, movimentoInsumo, className, ...rest } = props
  const { match: { params } } = props;
  const formRef = React.createRef(null);

  const { idLoja } = useSelector(state => state.usuarioLoja)
  const tipoMovimentoInsumo = useSelector((state) => state.tipoMovimentoInsumo.tipoMovimentoInsumo)
  const totvsInsumo = useSelector((state) => state.totvsInsumo.totvsInsumo)
  const totvsProduto = useSelector((state) => state.totvsProduto.totvsProduto)

  const [tipo, setTipo] = useState('insumo');

  useEffect(() => {
    if (params.id) {
      dispatch(movimentoInsumoAction.getMovimentoInsumoById(params.id))
    } else {
      dispatch(movimentoInsumoAction.clear())
    }

    dispatch(tipoMovimentoInsumoAction.getTipoMovimentoInsumoSelect())
    dispatch(totvsInsumoAction.getTotvsInsumoSelect())

  }, []);

  useEffect(() => {

    if (props.movimentoInsumo.idTotvsInsumo) {
      setTipo('insumo');
    } else if (props.movimentoInsumo.idTotvsProduto) {
      setTipo('produto');
    }

  }, [props.movimentoInsumo.isLoading])

  useEffect(() => {

    if (props.movimentoInsumo.idTotvsInsumo) {
      setTipo('insumo');
    } else if (props.movimentoInsumo.idTotvsProduto) {
      setTipo('produto');
    } else {
      setTipo('insumo');
    }

  }, [props.movimentoInsumo.idTotvsInsumo, props.movimentoInsumo.idTotvsProduto])

  useEffect(() => {

    if (idLoja) {
      dispatch(totvsProdutoAction.getTotvsProdutoByLojaSelect(idLoja))
    }

  }, [idLoja])

  const handleChange = (prop) => (event) => {
    dispatch(movimentoInsumoAction.onChangeProps(prop, event))
  }

  const handleTipoChange = (event) => {
    const value = event.target.value;
    setTipo(value);

    //Limpa o campo não selecionado
    if (value === 'insumo') {
      handleChange('idTotvsProduto')({ target: { value: '' } });
    } else {
      handleChange('idTotvsInsumo')({ target: { value: '' } });
    }
  };


  const handleSubmit = (event) => {

    let payload = {
      id: params.id,
      dataHora: moment(props.movimentoInsumo.dataHoraInicio).toISOString(),
      idTipoMovimentoInsumo: props.movimentoInsumo.idTipoMovimentoInsumo,
      idLoja: idLoja,
      idTotvsInsumo: props.movimentoInsumo.idTotvsInsumo || null,
      idTotvsProduto: props.movimentoInsumo.idTotvsProduto || null,
      quantidade: props.movimentoInsumo.quantidade,
      responsavel: props.movimentoInsumo.responsavel
    }

    if (params.id) {
      dispatch(movimentoInsumoAction.editMovimentoInsumoInfo(params.id, payload, true))
    } else {
      dispatch(movimentoInsumoAction.createMovimentoInsumo(payload))
    }
  };
  function InsertText() {
    return (
      <Typography variant="h4">
        <b>{'Nova Perda de Insumo'}</b>
      </Typography>
    )
  }

  return (
    <Page
      className={classes.root}
      title={
        params.id
          ? 'Gerência de Perdas de Insumos - Editar Perda de Insumo'
          : 'Gerência de Perdas de Insumos - Nova Perda de Insumo'
      }
    >
      <Grid
        {...rest}
        className={clsx(classes.root, className)}
        container
        spacing={3}
      >
        <Grid item lg={12} md={12} xl={12} xs={12}>
          <Grid item md={12} xs={12}>
            <Card>
              <ValidatorForm
                className={classes.form}
                ref={formRef}
                id="formMovimentoInsumo"
                onSubmit={(event) => handleSubmit(event)}
              >
                <CardHeader
                  subheader="Cadastro de Perda de Insumo"
                  title={(
                    params.id ?
                      <EditorHeader title='Editar Perda de Insumo' tabela='MovimentoInsumo' chave={params.id} props={props} />
                      :
                      <InsertText />
                  )}
                />
                <Divider />
                <CardContent >
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} xl={4} xs={12}>
                      <SelectValidator
                        className={classes.textField}
                        validators={['required']}
                        errorMessages={['Campo obrigatório!']}
                        variant="outlined"
                        id="idTipoMovimentoInsumo"
                        label="Tipo *"
                        value={props.movimentoInsumo.idTipoMovimentoInsumo}
                        onChange={handleChange('idTipoMovimentoInsumo')}
                        margin="normal"
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                        displayEmpty
                        labelId="idTipoMovimentoInsumo"
                      >
                        <MenuItem disabled value="">
                          <em>Tipo *</em>
                        </MenuItem>
                        {!isEmpty(tipoMovimentoInsumo) &&
                          undefined !== tipoMovimentoInsumo &&
                          tipoMovimentoInsumo.length &&
                          tipoMovimentoInsumo.map((row, index) => (
                            <MenuItem key={index} value={row.value}>
                              {row.text}
                            </MenuItem>
                          ))}
                      </SelectValidator>
                    </Grid>
                    <Grid item lg={3} md={3} xl={3} xs={12}>
                      <TextValidator
                        className={classes.textField}
                        fullWidth
                        type="datetime-local"
                        id="dataHora"
                        InputLabelProps={{ shrink: true }}
                        label="Data Início *"
                        onChange={handleChange('dataHora')}
                        validators={['required']}
                        errorMessages={['Campo obrigatório!']}
                        margin="normal"
                        value={props.movimentoInsumo.dataHora ? moment(props.movimentoInsumo.dataHora).format("yyyy-MM-DDTHH:mm") : moment().format("yyyy-MM-DDTHH:mm")}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">Informar perda de um:</FormLabel>
                        <RadioGroup row value={tipo} onChange={handleTipoChange}>
                          <FormControlLabel value="insumo" control={<Radio />} label="Insumo" />
                          <FormControlLabel value="produto" control={<Radio />} label="Produto" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item lg={6} md={6} xl={6} xs={12}>
  
                      <Autocomplete
                        id="idTotvsInsumo"
                        options={totvsInsumo}
                        getOptionLabel={(option) =>
                          option?.text ? `${option.text} (${option.unidade})` : ''
                        }
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        value={
                          totvsInsumo.find(
                            (item) =>
                              String(item.value) ===
                              String(props.movimentoInsumo.idTotvsInsumo)
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          handleChange('idTotvsInsumo')({
                            target: { value: newValue ? newValue.value : '' }
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Insumo"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                          />
                        )}
                        disabled={tipo !== 'insumo'}
                      />

                    </Grid>
                    <Grid item lg={6} md={6} xl={6} xs={12}>

                      <Autocomplete
                        id="idTotvsProduto"
                        options={totvsProduto}
                        getOptionLabel={(option) =>
                          option?.text ? option.text : ''
                        }
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        value={
                          totvsProduto.find(
                            (item) =>
                              String(item.value) ===
                              String(props.movimentoInsumo.idTotvsProduto)
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          handleChange('idTotvsProduto')({
                            target: { value: newValue ? newValue.value : '' }
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Produto"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                          />
                        )}
                        disabled={tipo !== 'produto'}
                      />

                    </Grid>
                    <Grid item lg={4} md={4} xl={4} xs={12}>
                      <TextValidator
                        className={classes.textField}
                        fullWidth
                        id="quantidade"
                        label="Quantidade *"
                        margin="normal"
                        type="number"
                        onChange={handleChange('quantidade')}
                        value={props.movimentoInsumo.quantidade || 0}
                        validators={['required']}
                        errorMessages={['Campo obrigatório!']}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item lg={12} md={12} xl={12} xs={12}>
                      <TextValidator
                        className={classes.textField}
                        fullWidth
                        id="responsavel"
                        label="Responsável"
                        margin="normal"
                        onChange={handleChange('responsavel')}
                        value={props.movimentoInsumo.responsavel || ''}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <Divider />
                <CardActions>
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Typography style={{ fontSize: "10px", paddingLeft: "6px" }}>
                      * Campos obrigatórios
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} xl={12} xs={12} style={{
                    display: 'flex',
                    alignItems: 'right',
                    flexDirection: 'row',
                    textAlgin: 'right',
                    justifyContent: 'right'
                  }}>
                    <Button
                      color="default"
                      onClick={() => history.push('/MovimentosInsumos')}
                      variant="contained"
                    >
                      Cancelar
                    </Button>
                    <Button
                      color="primary"
                      type="submit"
                      variant="contained"
                      disabled={props.movimentoInsumo.isLoading}
                      startIcon={<SaveIcon />}
                      endIcon={props.movimentoInsumo.isLoading && <CircularProgress size={24} />}
                    >
                      {params.id ? (props.movimentoInsumo.isLoading ? 'Atualizando movimentoInsumo...' : 'Atualizar') : (props.movimentoInsumo.isLoading ? 'Salvando movimentoInsumo...' : 'Salvar')}
                    </Button>
                  </Grid>
                </CardActions>
              </ValidatorForm>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Page>
  )
}

MovimentoInsumoEdit.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return state
}

const connectedMovimentoInsumoEditPage = withRouter(
  connect(mapStateToProps, null, null, {
    pure: false
  })(withStyles(styles)(MovimentoInsumoEdit))
)
export { connectedMovimentoInsumoEditPage as MovimentoInsumoEdit }
